(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sl-offer-bar"] && !Shopify.designMode) return;
  try {
    
    window.addEventListener('load', (event) => {
        const thisBar = document.querySelector('.shoplift-offer--bar--sticky');

        if (thisBar != null) {
            const thisHeader = document.querySelector('.shoplift-offerbar-wrapper');
            thisHeader.classList.add("shoplift-offer-bar-sticky");

            const mainHeader = document.querySelector('#shopify-section-header > sticky-header');

            const mainInitialTop = mainHeader.offsetTop;
            const stickyStart = mainHeader ? (mainHeader.offsetTop + mainHeader.clientHeight) : 0;
            let lastScroll = window.scrollY;
            document.addEventListener("scroll", (scrollEvent) => {
                if (!thisHeader) return;

                // Do it quick and dirty
                const mainHidden = mainHeader && (window.scrollY > lastScroll);
                lastScroll = window.scrollY;

                const makeSticky = window.pageYOffset > stickyStart || mainHeader && window.pageYOffset > mainInitialTop && mainHeader.parentElement.classList.contains("shopify-section-header-sticky");

                thisHeader.classList.toggle("shoplift-offer-bar-sticky", makeSticky);

                if (!makeSticky) return;

                let topPosition = 0;

                if (mainHeader && !mainHidden)
                    topPosition += mainHeader.clientHeight;

                thisHeader.style.top = topPosition + "px";
            });
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ticker-tracker"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {

    function updateNumbers(numbers) {
      const output = document.querySelector('[data-numbers]');
      if (!output || output.dataset.rendered === 'true') return;
      if (numbers == null) return;

      const formatted = numbers
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',');

      formatted.split('').forEach(char => {
        const div = document.createElement('div');
        if (char === ',') {
          div.classList.add('ticker-tracker__separator');
        } else {
          div.classList.add('ticker-tracker__number');
        }
        div.innerHTML = `<span>${char}</span>`;
        output.appendChild(div);
      });

      output.dataset.rendered = 'true';
    }



    async function fetchAndSumCol() {
      const endpointUrl = 'https://script.google.com/macros/s/AKfycbxjpL8M7FPPvYZrkXeAIYAx_BB1C2nxk1-RHv0d2k36Q4Zgap79LzCT9qyPbvJ_k82GQg/exec';

      try {
        const response = await fetch(endpointUrl);
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }

        const records = await response.json();

        const totalCol2 = records.reduce((sum, record) => {
          const value = parseInt(record.col2, 10);
          return sum + (isNaN(value) ? 0 : value);
        }, 0);

        console.log('Total of col2:', totalCol2);
        updateNumbers(totalCol2);
      } catch (err) {
        console.error('Error fetching or processing data:', err);
      }
    }

    fetchAndSumCol();
  });

  } catch(e) { console.error(e); }
})();
})();
